import { MainEnvironment } from './models/main-environment';

export const environment: MainEnvironment = {
  isProd: true,
  ultramarineBaseUrl: 'https://core.racapp.rentals/api/v1',
  umAuthBaseUrl: 'https://auth.racapp.rentals',
  authnBaseUrl: 'https://auth.racapp.rentals',
  umVerifyBaseUrl: 'https://reserve.racapp.rentals',
  protoApiBaseUrl: '',
  portalBaseUrl: 'https://portal.racapp.rentals',
  storageBaseUrl: 'https://storage-platform.racapp.rentals',
  tenantStorageBaseUrl: 'https://storage.racapp.rentals',
  umClientDomain: 'https://manage.racapp.rentals',
  bookkitBaseUrl: 'https://broker.racapp.rentals',
  businessBaseUrl: 'https://business.racapp.rentals',
  calendlyUrl: 'https://calendly.com/racapp/30min',
  productStatus: 'https://uptime.splitsecondconnect.cloud/status/racapp',
  mapboxAccessToken:
    'pk.eyJ1IjoibmVjdGFyaW9zZyIsImEiOiJjbXNrd2Z4Y28xMmlnMzBzZ3lmNTQwNG9kIn0.yr8FEYqEaRkdP5wTeDaPNA',
};
